import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M31 8c-3.861 0-7 3.136-7 7 0 3.861 3.136 7 7 7a7.01 7.01 0 0 0 6.929-6H43c1.333 0 1.333-2 0-2h-5.071A7.006 7.006 0 0 0 31 8m5 7.021v-.042A5.004 5.004 0 0 0 31 10c-2.757 0-5 2.241-5 5 0 2.757 2.241 5 5 5 2.75 0 4.989-2.23 5-4.979M5 16h16c1.333 0 1.333-2 0-2H5c-1.334 0-1.334 2 0 2m22 16h16c1.334 0 1.334 2 0 2H27c-1.333 0-1.333-2 0-2m-10 8c3.864 0 7-3.139 7-7 0-3.864-3.139-7-7-7a7.01 7.01 0 0 0-6.93 6H5c-1.334 0-1.334 2 0 2h5.07A7.01 7.01 0 0 0 17 40m0-12c2.757 0 5 2.241 5 5 0 2.757-2.241 5-5 5-2.757 0-5-2.241-5-5 0-2.757 2.241-5 5-5",
      clipRule: "evenodd"
    }
  )
);
var SvgPreferencesOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PreferencesOutlined_default = SvgPreferencesOutlined;

export { PreferencesOutlined_default as default };
